import { useState } from "react";

const testimonials = [
  {
    videoId: "fWZeK74x6Us",
    name: "Taís Pinheiro",
    location: "Sinop - MT • Modelo Internacional",
    initial: "T",
  },
  {
    videoId: "GEI7zFUsukk",
    name: "Beatriz Zachert",
    location: "Sorriso - MT • Modelo Internacional",
    initial: "B",
  },
  {
    videoId: "Xvk5lA_x5ic",
    name: "Douglas Malmman",
    location: "CEO da Mädchen Models • Modelo Internacional",
    initial: "D",
  },
  {
    videoId: "zLSADgvoVXI",
    name: "Valentina Marques",
    location: "Presidente Figueiredo - AM • Atriz",
    initial: "V",
  },
];

const stats = [
  { value: "+50.000", label: "Participantes em seletivas" },
  { value: "+1.000", label: "Talentos descobertos" },
  { value: "Brasil", label: "Inteiro atendido" },
];

function VideoCard({
  videoId,
  name,
  location,
  initial,
  isPlaying,
  onPlay,
}: {
  videoId: string;
  name: string;
  location: string;
  initial: string;
  isPlaying: boolean;
  onPlay: (id: string) => void;
}) {
  return (
    <div className="bg-gradient-to-br from-gray-900 to-black rounded-2xl overflow-hidden border border-yellow-500/20 flex flex-col">
      <div className="relative w-full aspect-video bg-black">
        {isPlaying ? (
          <iframe
            className="absolute inset-0 w-full h-full"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
            title={`Depoimento de ${name}`}
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        ) : (
          <div
            className="absolute inset-0 w-full h-full cursor-pointer group"
            onClick={() => onPlay(videoId)}
          >
            <img
              alt={`Depoimento de ${name}`}
              className="w-full h-full object-cover object-top"
              src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
            />
            <div className="absolute inset-0 bg-black/40 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-yellow-500 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-yellow-500/30">
                <i className="ri-play-fill text-black text-2xl sm:text-3xl ml-1" />
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="p-5 sm:p-6 flex-1 flex flex-col">
        <div className="flex items-center gap-1 mb-3">
          {[...Array(5)].map((_, i) => (
            <i key={i} className="ri-star-fill text-base sm:text-lg text-yellow-500" />
          ))}
        </div>
        <div className="flex items-center gap-3 mt-auto">
          <div className="w-10 h-10 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full flex items-center justify-center flex-shrink-0">
            <span className="text-black font-bold text-base">{initial}</span>
          </div>
          <div>
            <p className="text-white font-semibold text-sm">{name}</p>
            <p className="text-gray-500 text-xs">{location}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function SuccessStories() {
  const [playingId, setPlayingId] = useState<string | null>(null);

  return (
    <section className="py-16 sm:py-20 bg-black relative overflow-hidden" id="historias">
      <div className="absolute inset-0 opacity-10">
        <img
          alt="Background"
          className="w-full h-full object-cover object-top"
          src="https://public.readdy.ai/ai/img_res/67122e4cc465cbd92a825963f1911180.jpg"
        />
      </div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-10 sm:mb-14">
          <h4 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-3 px-4">
            Histórias de{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-yellow-600">
              Sucesso
            </span>
          </h4>
          <p className="text-base sm:text-lg text-gray-400 max-w-xl mx-auto">
            Assista os depoimentos de quem já passou pelas nossas seletivas.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6 mb-8 sm:mb-10">
          {testimonials.map((t) => (
            <VideoCard
              key={t.videoId}
              {...t}
              isPlaying={playingId === t.videoId}
              onPlay={setPlayingId}
            />
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-5">
          {stats.map((s) => (
            <div
              key={s.value}
              className="bg-yellow-500/10 border border-yellow-500/30 rounded-xl p-5 text-center"
            >
              <p className="text-2xl sm:text-3xl font-black text-yellow-500 mb-1">{s.value}</p>
              <p className="text-gray-400 text-xs sm:text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
